export default __webpack_public_path__ + "static/media/PalaikuSaugojimas.28ac9fe4.svg";